import * as React from "react";
import { Text, View, StyleSheet, Image, TouchableOpacity } from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import GenericButton from "../../components/GenericButton.js"

export default function WithdrawalNotificationConfirmScreen({route}) {
  const navigation = useNavigation();
  const sparkle = require("../../assets/res/sparkle.png");
  const accountValues = route.param
  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.modalContainerF}>
        <View style={styles.modalContainer}>
          <View style={styles.headerTextP}>
            <View>
              <Text style={styles.textStyleHeader}>Done!</Text>
              <Text style={styles.textStyleHeader}>Request sent.</Text>
            </View>
            <GenericButton
                    buttonText='CONTINUE'
                    onPress={() => navigation.navigate("MainMenu")}
                    buttonWidth={150}
                    buttonTextSize={12}
                    buttonColor= "#FFFFFF"
                  />
          </View>
          <View>
            <Image style={styles.sparkle} source={sparkle} />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  headerTextP: {
    position: "absolute",
    left: 0,
    top: 30,
    paddingLeft: 50,
    paddingRight: 10,
    width: 300,
  },
  modalContainer: {
    height: 190,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    paddingTop: 30,
    paddingRight: 30,
    paddingLeft: 30,
    width: 330,
  },
  modalContainerF: {
    marginTop: 190,
    paddingRight: 30,
    paddingLeft: 30,
    alignItems: "center",
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: -15,
    marginBottom: 20,
  },

  sparkle: {
    position: "absolute",
    top: -50,
    right: -50,
    width: 40,
    height: 40,
  },

  SubmitButtonStyle: {
    //marginTop: 10,
    paddingTop: 22,
    paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxWidth: "45%",
    alignContent: "center",
  },

  textStyleBack: {
    color: "#000000",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },

  buttonContainer: {
    width: "100%",
    position: "absolute",
    left: 20,
    bottom: -85,
  },
});
